<template>
    <div id="portal-orders">

        <b-modal ref="detail-modal" scrollable title="Détail commande" ok-only ok-title="Fermer" size="xl"
            cancel-variant="outline-secondary">
            <b-table :bordered="true" :small="true" :hover="true" :no-border-collapse="true" :items="orderLines"
                :fields="lineFields" />
        </b-modal>

        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :withFilters="true" :filterComponent="AgGridDateFilter" :agGrid="agGrid"
                    pageTitle="Commandes Portail" @refresh="loadData" @filterClicked="filterClicked" />
            </b-card>
        </b-overlay>

    </div>
</template>

<script>
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"
import BadgeCellRenderer from "@/views/components/ag-grid/BadgeCellRenderer.vue"
import AgGridDateFilter from '@/views/components/ag-grid/AgGridDateFilterCurrDate.vue';
import { formatPrice } from "@/utils/formatting";

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            AgGridDateFilter: AgGridDateFilter,
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
            showLoading: true,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "Client",
                        field: "Sell_to_Customer_No",
                    },
                    {
                        headerName: "Date Commande",
                        field: "Posting_Date",
                        valueGetter: function (tr) {
                            return tr.data.Posting_Date.substring(0, 10);
                        },
                    },
                     {
                        headerName: "N°",
                        field: "No",
                    },  
                    {
                        headerName: "N° BL",
                        field: "Last_Shipping_No",
                    },    
                    {
                        headerName: "Type",
                        field: "Gen_Prod_Posting_Group",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Orders", columnName: "Gen_Prod_Posting_Group" },
                    },
                    {
                        headerName: "Montant",
                        field: "Amount",
                        valueGetter: function (tr) {
                            return formatPrice(tr.data.Amount_Including_VAT);
                        },
                    },
                    {
                        headerName: "Statut",
                        field: "Order_Status",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "Orders", columnName: "Order_Status" },
                    },
                    {
                        sortable: false,
                        resizable: false,
                        filter: false,
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'buttonCellRenderer',
                        cellRendererParams: { onButtonClick: this.showDetails, icon: "read_more" },
                        headerName: '',
                        width: 100
                    },
                ],
                rows: []
            },
            lineFields: [
                { label: 'Code Article', key: 'No', sortable: true },
                { label: 'Désignation article', key: 'Description', sortable: true },
                { label: 'Prix', key: 'Unit_Price', sortable: true },
                { label: 'Quantité', key: 'Quantity', sortable: true },
            ],
            orderLines: [],
        }
    },
    created() {
        this.$options.components.buttonCellRenderer = ButtonCellRenderer;
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.loadData();
    },
    methods: {
        filterClicked(obj) {
            this.startDate = obj.sDate;
            this.endDate = obj.eDate;
            this.loadData();
        },
        async showDetails(event) {
            this.showLoading = true;
            let response = await this.$http.get("order_line/findWhere", {
                params: { Document_No: "'" + event.No + "'" }
            }).catch(() => { this.showLoading = false; });
            this.orderLines = response.data;
            this.showLoading = false;
            this.$refs['detail-modal'].show();
        },
        async loadData() {
            this.showLoading = true;
            let response = await this.$http.post("order_header/findWhere", this.generateDateFilters()).catch(() => {
                this.showLoading = false;
            });
            let rows = [...response.data].reverse();
            rows = rows.filter(x => x.No.substring(0, 2) !== 'RV');
            this.agGrid.rows = rows;
            this.showLoading = false;
        },
        generateDateFilters() {
            const startDateObj = new Date(this.startDate);
            startDateObj.setDate(startDateObj.getDate() - 1);
            const endDateObj = new Date(this.endDate);
            endDateObj.setDate(endDateObj.getDate() + 1);
            return [
                { field: "Posting_Date", value: startDateObj.toISOString().split('T')[0], operator: "gt" },
                { field: "Posting_Date", value: endDateObj.toISOString().split('T')[0], operator: "lt" },
                { field: "Web_Order", value: true, operator: "eq" },
            ];
        },
    }
}
</script>

<style lang="scss"></style>
